/**
 * WeaponHammer — heavy war hammer.
 * Wide rectangular hammerhead at the top; thick grip with wrap bands below.
 * Renders as an SVG <g> group in the knight's coordinate space (25×25).
 */
export default function WeaponHammer() {
  return (
    <g>
      {/* Hammerhead body */}
      <rect x="13.5" y="0.5" width="10" height="6"   rx="1"   fill="#8a9ab0"/>
      {/* Hammerhead top highlight */}
      <rect x="13.5" y="0.5" width="10" height="1.5" rx="0.6" fill="#b0c4d8" opacity="0.8"/>
      {/* Face strike plate */}
      <rect x="20.5" y="0.8" width="2.5" height="5.4" rx="0.4" fill="#c0d0e0"/>
      {/* Back bevelled face */}
      <rect x="13.8" y="0.8" width="2"   height="5.4" rx="0.4" fill="#a0b0c0" opacity="0.6"/>
      {/* Neck / eye socket */}
      <rect x="19.5" y="6"   width="3"   height="2"   rx="0.4" fill="#6a7a88"/>
      {/* Handle */}
      <rect x="20"   y="7.5" width="2"   height="15"  rx="0.7" fill="#7a5a3a"/>
      {/* Grip wraps */}
      <rect x="19.6" y="9.5" width="2.8" height="0.9" rx="0.3" fill="#9a7a5a" opacity="0.85"/>
      <rect x="19.6" y="13"  width="2.8" height="0.9" rx="0.3" fill="#9a7a5a" opacity="0.85"/>
      <rect x="19.6" y="17"  width="2.8" height="0.9" rx="0.3" fill="#9a7a5a" opacity="0.85"/>
      {/* Pommel */}
      <rect x="19.2" y="21.5" width="3.6" height="2"  rx="1"   fill="#5a4a38" stroke="#9ab0c8" strokeWidth="0.5"/>
    </g>
  );
}
